// eslint-disable-next-line
import Vue from 'vue'
import messages from '../i18n/messages'

Vue.prototype.$msg = messages
